var map = {
	"./en-us/cms.en-us.yml": 1990,
	"./en-us/forms.en-us.yml": 82820,
	"./en-us/landlord.en-us.yml": 36821,
	"./zh-cn/cms.zh-cn.yml": 78810,
	"./zh-cn/forms.zh-cn.yml": 25148,
	"./zh-cn/landlord.zh-cn.yml": 99733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25377;